export default {
    CALL_BACK_WITH_HIGHEST_PRIORITY: "CALL_BACK_WITH_HIGHEST_PRIORITY",
    DO_NOT_CALL_BACK: "DO_NOT_CALL_BACK"
};
